(function (angular) {
    'use strict';

    /**
     * Override IMessageManager interface and adapt responses on the fly for getConversationMessages() and getConversationEvents()
     */
    var MessageManager = (function () {

        function mapEvent(event) {

            event.conversationId = event.chatId;
            delete event.chatId;
            event.conversationEventId = event.chatEventId;
            delete event.chatEventId;
            event.payload.conversationId = event.payload.chatId;
            delete event.payload.chatId;

            // need to map the event name too ...
            event.name = event.name.replace("chatMessage", "conversationMessage");

            return event;
        }

        function mapOrphanedEvent(event) {
            event.data.payload.conversationId = event.data.payload.chatId;
            delete event.data.payload.chatId;
            return event;
        }

        function mapMessage(message) {
            message.context.conversationId = message.context.chatId;
            delete message.context.chatId;

            return message;
        }

        function MessageManager() { }
        MessageManager.prototype.initialise = function (_messageManager) {
            this._messageManager = _messageManager;
        }
        MessageManager.prototype.getConversationEvents = function (conversationId, from, limit) {
            return this._messageManager.getConversationEvents(conversationId, from, limit)
                .then(function (events) {
                    return events.map(mapEvent);
                });
        };
        MessageManager.prototype.getConversationMessages = function (conversationId, limit, from) {
            return this._messageManager.getConversationMessages(conversationId, limit, from)
                .then(function (result) {
                    if (result.messages) {
                        result.messages = result.messages.map(mapMessage);
                    }
                    if (result.orphanedEvents) {
                        result.orphanedEvents = result.orphanedEvents.map(mapOrphanedEvent);
                    }
                    return result;
                });

        };
        MessageManager.prototype.sendMessageToConversation = function (conversationId, message) {
            return this._messageManager.sendMessageToConversation(conversationId, message);
        };
        MessageManager.prototype.sendMessageStatusUpdates = function (conversationId, statuses) {
            return this._messageManager.sendMessageStatusUpdates(conversationId, statuses);
        };
        return MessageManager;
    }());

    angular.module('shared')
        .service('MessageManager', MessageManager);

})(window.angular);
